<template>
  <div>
    <a-menu v-model="currentType" mode="horizontal" style="margin-bottom: 10px">
      <a-menu-item key="KYJ" @click="toggleColumns('KYJ', 'getDeviceList')">{{ $t('binding.KYJ') }}</a-menu-item>
      <a-menu-item key="LGJ" @click="toggleColumns('LGJ', 'getLGJList')">{{ $t('binding.LGJ') }}</a-menu-item>
      <a-menu-item key="URC" @click="toggleColumns('URC', 'getUnRegistCustomers')">{{ $t('binding.unRegCustomer') }}</a-menu-item>
    </a-menu>
    <div class="container">
      <div class="order">
        <h2>{{ $t('binding.ordersQuery') }}</h2>
        <a-form-model layout="inline">
          <a-form-model-item :label="$t('binding.dateOut')">
            <a-date-picker v-model="date" />
          </a-form-model-item>
          <a-button type="primary" style="margin-top: 4px" @click="handleSearch">{{ $t('buttons.search') }}</a-button>
        </a-form-model>
        <a-table
          :columns="columns"
          :data-source="orders"
          :row-key="r => r.batch"
          :scroll="{ x: 1300, y: 645 }"
          :loading="isLoading"
        >
          <template v-slot:secondSale="text">
            <span :style="{ color: text ? 'red' : ''}">{{ text ? $t('common.yes') : $t('common.no')}}</span>
          </template>
        </a-table>
      </div>
      <div class="form">
        <div class="search">
          <h2>{{ $t('binding.searchConditions') }}</h2>
          <a-form-model layout="inline">
            <a-form-model-item :label="$t('device.code')">
              <a-input v-model="batch" />
            </a-form-model-item>
            <a-button
              type="primary"
              style="float: right; margin-right: 30px"
              :loading="isSearching"
              @click="getDetail"
            >{{ $t('buttons.search') }}</a-button>
            <a-button type="primary" style="float: right; margin-right: 10px" @click="resend">{{ $t('binding.resend') }}</a-button>
          </a-form-model>
        </div>
        <section class="device">
          <h2>{{ $t('device.deviceInfo') }}</h2>
          <a-form-model
            ref="form0"
            :model="form"
            :rules="rules"
            layout="inline"
            :labelCol="{ span: 7 }"
            :wrapperCol="{ span: 17 }"
          >
            <a-form-model-item :label="$t('common.deviceType')" prop="type">
              <a-select v-model="form.type" @change="handleTypeChange">
                <a-select-option
                  v-for="item in deviceTypeList"
                  :key="item.id"
                  :value="item.value"
                >{{ item.text }}</a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item :label="$t('common.deviceCode')" prop="batch">
              <a-input v-model="form.batch" />
            </a-form-model-item>
            <a-form-model-item :label="$t('common.deviceName')" prop="name">
              <a-input v-model="form.name" />
            </a-form-model-item>
            <a-form-model-item :label="$t('common.deviceAddress')" prop="deviceAddress">
              <a-input v-model="form.deviceAddress" />
            </a-form-model-item>
            <a-form-model-item :label="$t('common.model')" prop="productModel">
              <a-input v-model="form.productModel" />
            </a-form-model-item>
            <a-form-model-item :label="$t('binding.provideModel')">
              <a-input v-model="form.F_DEMAN_GFXH" />
            </a-form-model-item>
            <a-form-model-item :label="$t('common.protocolCode')" prop="protocolCode" v-show="currentType[0] === 'KYJ'">
              <a-select
                v-model="form.protocolCode"
                @change="handleProtocolChange"
                option-label-prop="label"
              >
                <a-select-option
                  :title="d.code + ' - ' + d.name"
                  v-for="d in protocolList"
                  :key="d.code"
                  :value="d.code"
                  :label="d.code"
                >{{ d.code }} - {{ d.name }}</a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item :label="$t('common.protocolCode')" prop="protocolCode" v-show="currentType[0] === 'LGJ'">
              <a-select
                show-search
                :value="form.protocolCode"
                :default-active-first-option="false"
                :show-arrow="false"
                :filter-option="false"
                :not-found-content="null"
                :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                @inputKeydown="getProtocolList"
                @change="selectProtocol"
                @popupScroll="handleProtocolPopupScroll"
              >
                <a-spin slot="notFoundContent" size="small" />
                <a-select-option
                  v-for="d in LGJProtocolList"
                  :key="d.id"
                  :value="d.code"
                >{{ d.code }} - {{ d.name }}</a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item :label="$t('common.driverType')" prop="driverType">
              <a-input disabled v-model="form.driverType" />
            </a-form-model-item>
            <a-form-model-item :label="$t('common.dtuCode')" prop="barcode" v-show="currentType[0] === 'LGJ'">
              <a-input v-model="form.barcode" />
            </a-form-model-item>
            <a-form-model-item :label="$t('common.dtuCode')" prop="barcode" v-show="currentType[0] === 'KYJ'">
              <a-input v-model="form.barcode" style="width: 60%" /><a-button type="primary" style="position: absolute; margin-left: 10px; margin-top: 4px" @click="getDtuCode" :loading="isDLoading">{{ $t('buttons.search') }}</a-button>
            </a-form-model-item>
            <a-form-model-item :label="$t('common.remark')">
              <a-textarea style="width: 724px" v-model="form.FNOTE" :auto-size="{ minRows: 2, maxRows: 6 }" />
            </a-form-model-item>
            <br />
            <a-form-model-item :label="$t('common.power')">
              <a-input v-model="form.power" />
            </a-form-model-item>
            <a-form-model-item :label="$t('common.pressure')">
              <a-input v-model="form.pressure" />
            </a-form-model-item>
            <!-- <a-form-model-item :label="$t('common.warrantyPeriod')">
              <a-input v-model="form.FDEMAN_ZJZB" />
            </a-form-model-item> -->
            <a-form-model-item :label="$t('SIM.status')">
              {{ simTypeMap[simType] }}<a-button type="primary" style="float: right; margin-left: 10px; margin-top: 4px" @click="activateSIM" :loading="isActivating">{{ $t('SIM.activate') }}</a-button>
            </a-form-model-item>
          </a-form-model>
        </section>
        <section class="customer">
          <h2>{{ $t('binding.customerInfo') }}</h2>
          <a-form-model
            ref="form1"
            layout="inline"
            :model="form"
            :rules="rules"
            :labelCol="{ span: 7 }"
            :wrapperCol="{ span: 17 }"
          >
            <a-form-model-item :label="$t('binding.customerName')" prop="customerName">
              <a-input style="width: 724px" v-model="form.customerName" />
            </a-form-model-item>
            <br />
            <a-form-model-item :label="$t('binding.acceptAddress')" prop="acceptAddress">
              <a-input style="width: 724px" v-model="form.acceptAddress" />
            </a-form-model-item>
            <br />
            <a-form-model-item :label="$t('orders.contactPerson')">
              <a-input v-model="form.contractManager" />
            </a-form-model-item>
            <a-form-model-item :label="$t('binding.contractPhone')" prop="contractPhone">
              <a-input style="width: 454px" v-model="form.contractPhone" />
            </a-form-model-item>
            <br />
            <a-form-model-item :label="$t('binding.province')" prop="province">
              <a-input v-model="form.province" />
            </a-form-model-item>
            <a-form-model-item :label="$t('binding.city')" prop="city">
              <a-input v-model="form.city" />
            </a-form-model-item>
            <a-form-model-item :label="$t('binding.provincial')" prop="provincial">
              <a-input v-model="form.provincial" />
            </a-form-model-item>
          </a-form-model>
        </section>
        <section class="service">
          <template>
            <h2>
              {{ $t('binding.serviceInfo') }}
              <a-button
                type="primary"
                style="float: right; margin-right: 47px"
                :loading="isRegisting"
                @click="validate"
              >{{ $t('binding.regist') }}</a-button>
            </h2>
            <a-form-model
              ref="form2"
              :model="form"
              :rules="rules"
              layout="inline"
              :labelCol="{ span: 7 }"
              :wrapperCol="{ span: 17 }"
            >
              <a-form-model-item :label="$t('binding.salesMen')" prop="employeeName">
                <!-- <a-input v-model="form.employeeName@change="selectOrganization"
                " />-->
                <a-select
                  style="width: 320px"
                  show-search
                  :value="form.employeeName"
                  :placeholder="$t('binding.ssm')"
                  :default-active-first-option="false"
                  :show-arrow="false"
                  :filter-option="false"
                  :not-found-content="null"
                  :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                  @inputKeydown="getUserList"
                  @change="selectUser"
                  @popupScroll="handleSalesPopupScroll"
                >
                  <a-spin slot="notFoundContent" size="small" />
                  <a-select-option
                    v-for="d in users"
                    :key="d.id"
                    :value="d.id"
                  >{{ d.realName }} - {{ d.role }} - {{ d.username }}</a-select-option>
                </a-select>
              </a-form-model-item>
              <a-form-model-item :label="$t('binding.salesPhone')" style="margin-left: 171px">
                <a-input disabled style="width: 280px" v-model="form.salesPhone" />
              </a-form-model-item>
              <br />
              <a-form-model-item :label="$t('binding.serviceMan')" prop="serviceMan">
                <!-- <a-input /> -->
                <a-select
                  style="width: 320px"
                  show-search
                  :value="form.serviceMan"
                  :placeholder="$t('binding.ssem')"
                  :default-active-first-option="false"
                  :show-arrow="false"
                  :filter-option="false"
                  :not-found-content="null"
                  :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                  @inputKeydown="getServiceList"
                  @change="selectService"
                  @popupScroll="handleServiceMansPopupScroll"
                >
                  <a-select-option
                    v-for="d in serviceMan"
                    :key="d.id"
                    :value="d.id"
                  >{{ d.realName }} - {{ d.role }} - {{ d.username }}</a-select-option>
                </a-select>
              </a-form-model-item>
              <a-form-model-item :label="$t('binding.servicePhone')" style="margin-left: 171px">
                <a-input disabled style="width: 280px" v-model="form.servicePhone" />
              </a-form-model-item>
            </a-form-model>
          </template>
        </section>
      </div>
      <a-modal
        :title="role"
        :visible="visible"
        @ok="usersVisible = true; visible = false;"
        @cancel="visible = false"
      >
        <p>
          {{ $t('binding.current') }}{{role}}
          <strong>{{ realName }}</strong> {{ $t('binding.dontExit') }}
        </p>
      </a-modal>
      <UserModal :visible="usersVisible" :authorities="authorities" :id="record.id" :closeModl="closeModal" :afterClose="handleAfterClose" :info="record" :mobile="mobile" :realName="realName" />
      <div v-show="isConfirmShow">
        <div
          class="ant-modal-root ant-modal-confirm ant-modal-confirm-confirm ant-modal-confirm ant-modal-confirm-confirm ant-modal-confirm"
        >
          <div class="ant-modal-mask"></div>
          <div tabindex="-1" role="dialog" class="ant-modal-wrap">
            <div
              role="document"
              class="ant-modal"
              style="width: 520px; transform-origin: 554px 143px;"
            >
              <div
                tabindex="0"
                aria-hidden="true"
                style="width: 0px; height: 0px; overflow: hidden;"
              ></div>
              <div class="ant-modal-content">
                <div class="ant-modal-body">
                  <div class="ant-modal-confirm-body-wrapper">
                    <div class="ant-modal-confirm-body">
                      <i aria-label="icon: question-circle" class="anticon anticon-question-circle">
                        <svg
                          viewBox="64 64 896 896"
                          data-icon="question-circle"
                          width="1em"
                          height="1em"
                          fill="currentColor"
                          aria-hidden="true"
                          focusable="false"
                          class
                        >
                          <path
                            d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                          />
                          <path
                            d="M623.6 316.7C593.6 290.4 554 276 512 276s-81.6 14.5-111.6 40.7C369.2 344 352 380.7 352 420v7.6c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V420c0-44.1 43.1-80 96-80s96 35.9 96 80c0 31.1-22 59.6-56.1 72.7-21.2 8.1-39.2 22.3-52.1 40.9-13.1 19-19.9 41.8-19.9 64.9V620c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-22.7a48.3 48.3 0 0 1 30.9-44.8c59-22.7 97.1-74.7 97.1-132.5.1-39.3-17.1-76-48.3-103.3zM472 732a40 40 0 1 0 80 0 40 40 0 1 0-80 0z"
                          />
                        </svg>
                      </i>
                      <span class="ant-modal-confirm-title">{{ $t('binding.continue') }}</span>
                      <div class="ant-modal-confirm-content" style="padding-top: 7px">
                        <!-- <div>点击确认继续注册，点击取消返回编辑</div> -->
                        <div v-for="(c, i) in confirmContent" :key="i" style="font-size: 16px; margin-top: 8px;">{{ i + 1}}、{{ c }}</div>
                      </div>
                    </div>
                    <div class="ant-modal-confirm-btns">
                      <button @click="isConfirmShow=false; isRegisting=false" type="button" class="ant-btn">
                        <span>{{ $t('common.cancelText') }}</span>
                      </button>
                      <button @click="regist" type="button" class="ant-btn ant-btn-primary">
                        <span>{{ $t('common.okText') }}</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div
                tabindex="0"
                aria-hidden="true"
                style="width: 0px; height: 0px; overflow: hidden;"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getDict } from "@/api/dict";
import { searchProtocolCode } from "@/api/protocol";
import { getDeviceList, getDeviceDetail, getLGJList, getDtuCode } from "@/api/deviceBind";
import {
  searchDeviceList,
  updateDevice,
  addDevice,
  postUnRegCustomer,
  getSIMs,
  activateSIM
} from "@/api/device";
import {
  searchCustomerList,
  addCustomer,
  getCustomerById,
  updateCustomer
} from "@/api/customer";
import { searchUserList, addUser } from "@/api/auth/user";
import {
  searchOrganizationList,
  getOrganizationList
} from "@/api/auth/organization";

import { searchRoleList, getRoleList } from "@/api/auth/role";
import moment from "moment";
import UserModal from '@/components/common/UserModal.vue'
import { f } from '@/api/order'

export default {
  components: {
    UserModal
  },
  data() {
    return {
      columnsMap: {
        KYJ: [
          {
            title: () => this.$t('binding.orderCode'),
            dataIndex: "FBILLNO",
            key: "FBILLNO",
            width: 170
          },
          {
            title: () => this.$t('common.deviceCode'),
            dataIndex: "batch",
            key: "batch",
            width: 150
          },
          {
            title: () => this.$t('binding.secondSale'),
            dataIndex: "secondSale",
            key: "secondSale",
            scopedSlots: {
              customRender: "secondSale"
            },
            width: 100
          },
          {
            title: () => this.$t('common.customerName'),
            dataIndex: "customerName",
            key: "customerName",
            width: 200
          },
          {
            title: () => this.$t('common.salesMen'),
            dataIndex: "employeeName",
            key: "employeeName"
          },
          {
            title: () => this.$t('binding.terminalCustomer'),
            dataIndex: "terminalCustomerName",
            key: "terminalCustomerName",
            width: 180
          },
          {
            title: () => this.$t('binding.contractManager'),
            dataIndex: "contractManager",
            key: "contractManager"
          },
          {
            title: () => this.$t('binding.saleDepartment'),
            dataIndex: "departmentName",
            key: "departmentName"
          }
        ],
        LGJ: [
          {
            title: () => this.$t('binding.orderCode'),
            dataIndex: "FBILLNO",
            key: "FBILLNO",
            width: 170
          },
          {
            title: () => this.$t('common.deviceCode'),
            dataIndex: "batch",
            key: "batch",
            width: 150
          },
          {
            title: () => this.$t('binding.hostCode'),
            dataIndex: "zjbh",
            key: "zjbh",
            width: 110
          }, 
          {
            title: () => this.$t('binding.ygkCustomer'),
            dataIndex: "ygkCustomer",
            key: "ygkCustomer",
            width: 200
          },
          {
            title: () => this.$t('common.customerName'),
            dataIndex: "customerName",
            key: "customerName",
            width: 200
          },
          {
            title: () => this.$t('common.salesMen'),
            dataIndex: "employeeName",
            key: "employeeName"
          },
          {
            title: () => this.$t('binding.terminalCustomer'),
            dataIndex: "terminalCustomerName",
            key: "terminalCustomerName",
            width: 180
          },
          {
            title: () => this.$t('binding.contractManager'),
            dataIndex: "contractManager",
            key: "contractManager"
          },
          {
            title: () => this.$t('binding.saleDepartment'),
            dataIndex: "departmentName",
            key: "departmentName"
          }
        ],
        URC: [
          {
            title: () => this.$t('common.customerName'),
            dataIndex: "customerName",
            key: "customerName",
            width: 200
          },
          {
            title: () => this.$t('binding.customerShortName'),
            dataIndex: "customerShortName",
            key: "customerShortName"
          },
          {
            title: () => this.$t('orders.contactPerson'),
            dataIndex: "shr",
            key: "shr"
          },
          {
            title: () => this.$t('device.mobile'),
            dataIndex: "shrPhone",
            key: "shrPhone"
          },
          {
            title: () => this.$t('binding.shrAddress'),
            dataIndex: "shrAddress",
            key: "shrAddress"
          },
          {
            title: () => this.$t('binding.areaManager'),
            dataIndex: "am",
            key: "am"
          }
        ]
      },
      columns: [],
      orders: [],
      deviceTypeList: [],
      isConfirmShow: false,
      followerForm: {
        followeId: '',
        followerPhone: '',
        followerName: '',
      },
      followeId: '',
      followerPhone: '',
      followerName: '',
      form: {
        type: "KYJ",
        name: "空压机",
        deviceAddress: "02",
        protocolCode: "",
        driverType: "MODBUS_RTU",
        batch: "",
        productModel: "",
        F_DEMAN_GFXH: "",
        barcode: "",
        FNOTE: "",
        power: "",
        pressure: "",
        FDEMAN_ZJZB: "",
        customerName: "",
        acceptAddress: "",
        contractManager: "",
        contractPhone: "",
        province: "",
        city: "",
        provincial: "",
        employeeName: "",
        salesPhone: "",
        salesId: "",
        serviceMan: "",
        servicePhone: "",
        serviceId: ""
      },
      followUserList: [],
      protocolList: [
        {
          code: "KYJ000002"
        }
      ],
      date: "",
      batch: "",
      isLoading: false,
      isSearching: false,
      isRegisting: false,
      users: [],
      serviceMan: [],
      sa: "",
      usersVisible: false,
      visible: false,
      realName: '',
      rules: {
        realName: [
          {
            required: true,
            message: this.$t('messages.peu'),
            trigger: "blur"
          }
        ],
        username: [
          {
            required: true,
            message: this.$t('messages.pem'),
            trigger: "blur"
          }
        ],
        contractPhone: [
          {
            message: this.$t('messages.pemp'),
            validator: this.validatePhone,
            trigger: "blur"
          }
        ],
        organizationId: [
          {
            required: true,
            message: this.$t('messages.peo')
          }
        ],
        roleId: [
          {
            required: true,
            message: this.$t('messages.per')
          }
        ],
        type: [
          {
            required: true,
            message: this.$t('messages.pedt')
          }
        ],
        batch: [
          {
            required: true,
            message: this.$t('messages.pedc')
          }
        ],
        name: [
          {
            required: true,
            message: this.$t('messages.pedn'),
            trigger: "blur"
          }
        ],
        deviceAddress: [
          {
            required: true,
            message: this.$t('messages.peda'),
            trigger: "blur"
          }
          // {
          //   min: 2,
          //   max: 2,
          //   message: '站号地址必须为2位',
          //   trigger: 'blur'
          // },
          // {
          //   validator(rule, value, callback) {
          //     if (value === '16') {
          //       return callback('请输入正确的16进制地址')
          //     }
          //     const reg = new RegExp(/^[0-9a-f]+$/i)
          //     if(reg.test(value)) {
          //       callback()
          //     } else {
          //       callback(reg.test(value))
          //     }
          //   },
          //   message: '请输入正确的16进制地址',
          //   trigger: 'blur'
          // }
        ],
        productModel: [
          {
            required: true,
            message: this.$t('messages.pedm'),
            trigger: "blur"
          }
        ],
        protocolCode: [
          {
            required: true,
            message: this.$t('messages.pedp'),
            trigger: "blur"
          }
        ],
        driverType: [
          {
            required: true,
            message: this.$t('messages.pedd'),
            trigger: "blur"
          }
        ],
        barcode: [
          {
            required: true,
            message: this.$t('messages.pedtu'),
            trigger: "blur"
          }
        ],
        customerName: [
          {
            required: true,
            message: this.$t('messages.company_empty'),
            trigger: "blur"
          }
        ],
        acceptAddress: [
          {
            required: true,
            message: this.$t('messages.address_empty'),
            trigger: "blur"
          }
        ],
        province: [
          {
            required: true,
            message: this.$t('binding.ep'),
            trigger: "blur"
          }
        ],
        city: [
          {
            required: true,
            message: this.$t('binding.ec'),
            trigger: "blur"
          }
        ],
        provincial: [
          {
            required: true,
            message: this.$t('binding.epr'),
            trigger: "blur"
          }
        ],
        employeeName: [
          {
            required: true,
            message: this.$t('binding.ssm')
          }
        ],
        serviceMan: [
          {
            required: true,
            message: this.$t('binding.ssem')
          }
        ]
      },
      labelCol: { span: 4 },
      wrapperCol: { span: 16 },
      organizations: [],
      roles: [],
      isUserLoading: false,
      role: this.$t('common.salesMen'),
      currentType: ["KYJ"],
      confirmContent: [],
      authorities: [],
      record: {
        id: 0
      },
      mobile: '',
      isDLoading: false,
      LGJProtocolList: [],
      simTypeMap: {},
      simType: '',
      isActivating: false
    };
  },
  computed: {
    lang() {
      return this.$store.state.lang
    }
  },
  watch: {
    lang: {
      immediate: true,
      handler() {
        this.translate()
      }
    }
  },
  created() {
    this.protocolMap = {}
    this.authorities = this.authorities.concat(this.getAuthorities('/user'))
    this.date = moment(+new Date() - 24 * 1000 * 3600 + 1);
    this.searchFlag = true;
    getDict("zh-CN", "deviceType").then(({ data }) => {
      this.deviceTypeList = data.content;
    });
    getDict("zh-CN", "smarthingSIMStatus").then(({ data }) => {
      const simTypeMap = {
        "空": "空"
      }
      data.content.forEach(c => {
        simTypeMap[c.value] = c.text
      })
      this.simTypeMap = simTypeMap
    });
    getDict("zh-CN", "version").then(({ data }) => {
      this.versionList = data.content.map(c => {
        return {
          ...c,
          text: c.text === "无" ? c.text : c.text.split("@")[1]
        };
      });
    });
    searchProtocolCode(1, 20, "KYJ", "KYJ").then(({ data }) => {
      this.protocolList = data.records.filter(p => p.code.length === 9);
      this.protocolMap.KYJ = data.records.filter(p => p.code.length === 9)
      if (data.total <= 10) {
        this.searchFlag = false;
      }
    });
    searchProtocolCode(1, 20, "YRHS", "YRHS").then(({ data }) => {
      this.protocolMap.YRHS = data.records
    });
    searchProtocolCode(1, 20, "ZKB", "ZKB").then(({ data }) => {
      this.protocolMap.ZKB = data.records
    });
    searchProtocolCode(1, 20, "GFJ", "GFJ").then(({ data }) => {
      this.protocolMap.GFJ = data.records
    });
    this.sSearchFlag = true;
    this.seSearchFlag = true;
    this.pointer = ['province', 'city', 'area', 'address']
    
    
    // const { data } = await f()
    // this.serviceManList = JSON.parse(data[0].list)
    // console.log(this.serviceManList);
    
    // const result = await u([{
    //   list: JSON.stringify(this.serviceManList)
    // }])
    // console.log(result);
    this.getServiceManList()
    
  },
  async mounted() {
    this.toggleColumns('KYJ', 'getDeviceList')
    this.getAllOrga();
    this.getAllRole();
  },
  methods: {
    translate() {
      this.role = this.$t('common.salesMen')
      this.rules = {
        realName: [
          {
            required: true,
            message: this.$t('messages.peu'),
            trigger: "blur"
          }
        ],
        username: [
          {
            required: true,
            message: this.$t('messages.pem'),
            trigger: "blur"
          }
        ],
        contractPhone: [
          {
            message: this.$t('messages.pemp'),
            validator: this.validatePhone,
            trigger: "blur"
          }
        ],
        organizationId: [
          {
            required: true,
            message: this.$t('messages.peo')
          }
        ],
        roleId: [
          {
            required: true,
            message: this.$t('messages.per')
          }
        ],
        type: [
          {
            required: true,
            message: this.$t('messages.pedt')
          }
        ],
        batch: [
          {
            required: true,
            message: this.$t('messages.pedc')
          }
        ],
        name: [
          {
            required: true,
            message: this.$t('messages.pedn'),
            trigger: "blur"
          }
        ],
        deviceAddress: [
          {
            required: true,
            message: this.$t('messages.peda'),
            trigger: "blur"
          }
          // {
          //   min: 2,
          //   max: 2,
          //   message: '站号地址必须为2位',
          //   trigger: 'blur'
          // },
          // {
          //   validator(rule, value, callback) {
          //     if (value === '16') {
          //       return callback('请输入正确的16进制地址')
          //     }
          //     const reg = new RegExp(/^[0-9a-f]+$/i)
          //     if(reg.test(value)) {
          //       callback()
          //     } else {
          //       callback(reg.test(value))
          //     }
          //   },
          //   message: '请输入正确的16进制地址',
          //   trigger: 'blur'
          // }
        ],
        productModel: [
          {
            required: true,
            message: this.$t('messages.pedm'),
            trigger: "blur"
          }
        ],
        protocolCode: [
          {
            required: true,
            message: this.$t('messages.pedp'),
            trigger: "blur"
          }
        ],
        driverType: [
          {
            required: true,
            message: this.$t('messages.pedd'),
            trigger: "blur"
          }
        ],
        barcode: [
          {
            required: true,
            message: this.$t('messages.pedtu'),
            trigger: "blur"
          }
        ],
        customerName: [
          {
            required: true,
            message: this.$t('messages.company_empty'),
            trigger: "blur"
          }
        ],
        acceptAddress: [
          {
            required: true,
            message: this.$t('messages.address_empty'),
            trigger: "blur"
          }
        ],
        province: [
          {
            required: true,
            message: this.$t('binding.ep'),
            trigger: "blur"
          }
        ],
        city: [
          {
            required: true,
            message: this.$t('binding.ec'),
            trigger: "blur"
          }
        ],
        provincial: [
          {
            required: true,
            message: this.$t('binding.epr'),
            trigger: "blur"
          }
        ],
        employeeName: [
          {
            required: true,
            message: this.$t('binding.ssm')
          }
        ],
        serviceMan: [
          {
            required: true,
            message: this.$t('binding.ssem')
          }
        ]
      }
    },
    async getServiceManList() {
      try {
        const { data } = await f()
        this.serviceManList = data[0]
      } catch(e) {
        console.log(e)
        this.serviceManList = []
      }
    },
    closeModal() {
      this.usersVisible = false
    },
    async getDeviceList() {
      if (!this.date) {
        return this.$message.error(this.$t('device.selectDate'));
      }
      this.isLoading = true;
      // console.log(this.date.format('YYYY-MM-DD'));
      try {
        const { data } = await getDeviceList(this.date.format("YYYY-MM-DD"));
        this.orders = data;
      } catch (e) {
        console.log(e);
      } finally {
        this.isLoading = false;
      }
    },
    async getLGJList() {
      if (!this.date) {
        return this.$message.error(this.$t('device.selectDate'));
      }
      this.isLoading = true
      try {
        const { data } = await getLGJList(this.date.format("YYYY-MM-DD"));
        this.orders = data
      } catch(e) {
        console.log(e)
      } finally {
        this.isLoading = false
      }
    },
    async handleTypeChange(value) {
      if (this.protocolMap[value]) {
        if (this.currentType[0] === 'KYJ') {
          this.protocolList = this.protocolMap[value]
        }
        if (this.currentType[0] === 'LGJ') {
          this.LGJProtocolList = this.protocolMap[value]
        }
      } else {
        if (this.currentType[0] === 'KYJ') {
          this.protocolList = this.protocolMap['KYJ']
        }
        if (this.currentType[0] === 'LGJ') {
          this.LGJProtocolList = []
        }
      }
      const type = this.deviceTypeList.find(d => d.value === value)
      if (type) {
        this.form.name = type.text
      }
    },
    async handleSalesPopupScroll(e) {
      if (!this.sSearchFlag) {
        return;
      }
      const { scrollHeight, scrollTop, clientHeight } = e.target;
      if (scrollHeight - scrollTop === clientHeight) {
        this.usersPage++;
        const { data } = await searchUserList(this.usersPage, 10, {
          query: [
            {
              field: "realName",
              value: this.o.trim()
            }
          ],
          filter: [],
          sort: []
        });
        this.users = this.users.concat(data.records);
        if (this.users.length >= data.total) {
          this.sSearchFlag = false;
        }
      }
    },
    async handleServiceMansPopupScroll(e) {
      if (!this.seSearchFlag) {
        return;
      }
      const { scrollHeight, scrollTop, clientHeight } = e.target;
      if (scrollHeight - scrollTop === clientHeight) {
        this.servicePage++;
        const { data } = await searchUserList(this.servicePage, 10, {
          query: [
            {
              field: "realName",
              value: this.s.trim()
            }
          ],
          filter: [],
          sort: []
        });
        this.serviceMan = this.serviceMan.concat(data.records);
        if (this.serviceMan.length >= data.total) {
          this.seSearchFlag = false;
        }
      }
    },
    getDetail() {
      this.batch = this.batch.trim();
      if (!this.batch) {
        return this.$message.warning(this.$t('binding.eqdc'));
      }
      this.isSearching = true;
      this[`handle${this.currentType[0]}Search`]();
    },
    async handleKYJSearch() {
      try {
        this.giccid = null
        this.simType = ''
        const code = this.batch.split("-").join("")
        const { data } = await getDeviceDetail(code)
        this.form.batch = data.batch;
        this.form.productModel = data.productModel;
        this.form.F_DEMAN_GFXH = data.F_DEMAN_GFXH;
        this.form.barcode = data.barcode;
        this.form.FNOTE = data.note;
        const powerArr = code.split("")
        let p = "", flag = true
        for (let i = 1; i < 4; i++) {
          if (flag) {
            if (+powerArr[i] !== 0) {
              p += powerArr[i]
              flag = false
            }
          } else {
            p += powerArr[i]
          }
        }
        this.form.power = p;
        this.form.pressure = data.pressure;
        this.form.FDEMAN_ZJZB = data.FDEMAN_ZJZB;
        if (data.protocolID) {
          this.form.protocolCode = data.protocolID
          if (data.F_DMKD_RJBB && data.F_DMKD_RJBB !== '11') {
            const version = this.versionList.find(
              v => v.value === data.F_DMKD_RJBB
            );
            const protocol = this.protocolList.find(p => p.code === version?.text)
            if (protocol && protocol.code !== this.form.protocolCode) {
              // this.$message.warn('协议编号与设定协议编号不同，设定为：' + version?.text)
              this.$confirm({
                title: this.$t("binding.confirmProtocolCode"),
                content: this.$t("binding.diffProtocolCode") + version?.text
              })
            }
          } else if (data.F_DMKD_RJBB === '11') {
            this.form.protocolCode = ''
          }
        } else {
          if (data.F_DMKD_RJBB) {
            if (data.F_DMKD_RJBB === '11') {
              this.form.protocolCode = ""
            } else {
              const version = this.versionList.find(
                v => v.value === data.F_DMKD_RJBB
              );
              const protocol = this.protocolList.find(p => p.code === version?.text)
              if (protocol) {
                this.form.protocolCode = version.text
              } else {
                this.form.protocolCode = ""
              }
            }
          }
        }
        let customerId, c
        if (data.terminalCustomerName?.trim()) {
          this.form.customerName = data.terminalCustomerName.trim();
          customerId = await this.searchCustomer(this.form.customerName)
          if (customerId) {
            c = await getCustomerById(customerId)
            this.form.acceptAddress = c.data.address || data.terminalacceptAddress;
            let cp = (c.data.mobile || "").trim()
            if (cp.length > 8) {
              this.form.contractManager = c.data.contactPerson
              this.form.contractPhone = c.data.mobile
            } else {
              this.form.contractManager = data.terminalcontractManager
              this.form.contractPhone = data.terminalcontractPhone
            }
            this.form.province = c.data.province || data.province;
            this.form.city = c.data.city || data.city;
            this.form.provincial = c.data.area || data.provincial;
          } else {
            this.form.acceptAddress = data.terminalacceptAddress;
            this.form.contractManager = data.terminalcontractManager;
            this.form.contractPhone = data.terminalcontractPhone;
            this.form.province = data.province;
            this.form.city = data.city;
            this.form.provincial = data.provincial;
          }
        } else {
          this.form.customerName = data.customerName;
          customerId = await this.searchCustomer(this.form.customerName)
          if (customerId) {
            c = await getCustomerById(customerId)
            this.form.acceptAddress = c.data.address || data.acceptAddress;
            let cp = (c.data.mobile || "").trim()
            if (cp.length > 8) {
              this.form.contractManager = c.data.contactPerson
              this.form.contractPhone = c.data.mobile
            } else {
              this.form.contractManager = data.contractManager
              this.form.contractPhone = data.contractPhone
            }
            // this.form.contractManager = c.data.contactPerson || data.contractManager;
            // this.form.contractPhone = c.data.mobile || data.contractPhone;
            this.form.province = c.data.province || data.province;
            this.form.city = c.data.city || data.city;
            this.form.provincial = c.data.area || data.provincial;
          } else {
            this.form.acceptAddress = data.acceptAddress;
            this.form.contractManager = data.contractManager;
            this.form.contractPhone = data.contractPhone;
            this.form.province = data.province;
            this.form.city = data.city;
            this.form.provincial = data.provincial;
          }
        }
        this.form.employeeName = data.employeeName;
        this.form.salesPhone = "";
        this.form.serviceMan = "";
        this.form.servicePhone = "";
        this.form.serviceId = "";
        this.users = [];
        this.serviceMan = [];
        if (data.departmentNumber.startsWith("06.02")) {
          let customerId = await this.searchCustomer(data.customerName);
          if (customerId) {
            const c = await getCustomerById(customerId);
            const customer = c.data;
            if (customer.users?.length) {
              this.form.employeeName = customer.users[0].realName;
              this.form.salesPhone = customer.users[0].username;
              this.form.salesId = customer.users[0].id;
              this.form.serviceMan = customer.users[0].realName;
              this.form.servicePhone = customer.users[0].username;
              this.form.serviceId = customer.users[0].id;
            }
            if (customer.salesmen?.length) {
              this.form.employeeName = customer.salesmen[0].realName;
              this.form.salesPhone = customer.salesmen[0].username;
              this.form.salesId = customer.salesmen[0].id;
            }
            if (customer.serviceMans?.length) {
              this.form.serviceMan = customer.serviceMans[0].realName;
              this.form.servicePhone = customer.serviceMans[0].username;
              this.form.serviceId = customer.serviceMans[0].id;
            }
          } else {
            this.form.employeeName = this.form.employeeName?.trim() || ''
            if (this.form.employeeName && this.form.employeeName.length >= 2) {
              const { data } = await searchUserList(1, 10, {
                query: [
                  {
                    field: 'realName',
                    value: this.form.employeeName
                  }
                ],
                filter: [],
                sort: []
              })
              if (data.total > 0) {
                this.form.employeeName = data.records[0].realName
                this.form.salesPhone = data.records[0].username
                this.form.salesId = data.records[0].id
              }
            }
            this.form.serviceMan = this.form.serviceMan?.trim() || ''
            if (this.form.serviceMan && this.form.serviceMan.length >= 2) {
              const { data } = await searchUserList(1, 10, {
                query: [
                  {
                    field: 'realName',
                    value: this.form.serviceMan
                  }
                ],
                filter: [],
                sort: []
              })
              if (data.total > 0) {
                this.form.serviceMan = data.records[0].realName
                this.form.servicePhone = data.records[0].username
                this.form.serviceId = data.records[0].id
              }
            }
          }
        } else if (data.departmentNumber.startsWith("06.03")) {
          let customerId
          if (data.terminalCustomerName?.trim()) {
            customerId = await this.searchCustomer(data.terminalCustomerName.trim())
          }
          if (customerId) {
            const c = await getCustomerById(customerId)
            const customer = c.data
            if (customer.users?.length) {
              this.form.employeeName = customer.users[0].realName;
              this.form.salesPhone = customer.users[0].username;
              this.form.salesId = customer.users[0].id;
              this.form.serviceMan = customer.users[0].realName;
              this.form.servicePhone = customer.users[0].username;
              this.form.serviceId = customer.users[0].id;
            }
            if (customer.salesmen?.length) {
              this.form.employeeName = customer.salesmen[0].realName;
              this.form.salesPhone = customer.salesmen[0].username;
              this.form.salesId = customer.salesmen[0].id;
            }
            if (customer.serviceMans?.length) {
              this.form.serviceMan = customer.serviceMans[0].realName;
              this.form.servicePhone = customer.serviceMans[0].username;
              this.form.serviceId = customer.serviceMans[0].id;
            }
          } else {
            customerId = await this.searchCustomer(data.customerName)
            if (customerId) {
              const c = await getCustomerById(customerId)
              const customer = c.data
              if (customer.users?.length) {
                this.form.employeeName = customer.users[0].realName;
                this.form.salesPhone = customer.users[0].username;
                this.form.salesId = customer.users[0].id;
                this.form.serviceMan = customer.users[0].realName;
                this.form.servicePhone = customer.users[0].username;
                this.form.serviceId = customer.users[0].id;
              }
              if (customer.salesmen?.length) {
                this.form.employeeName = customer.salesmen[0].realName;
                this.form.salesPhone = customer.salesmen[0].username;
                this.form.salesId = customer.salesmen[0].id;
              }
              if (customer.serviceMans?.length) {
                this.form.serviceMan = customer.serviceMans[0].realName;
                this.form.servicePhone = customer.serviceMans[0].username;
                this.form.serviceId = customer.serviceMans[0].id;
              }
            }
          }
        } else {
          const res = await searchUserList(1, 10, {
            query: [
              {
                field: "realName",
                value: this.form.employeeName
              }
            ],
            filter: [],
            sort: []
          });
          if (res.data.total > 0) {
            this.form.employeeName = res.data.records[0].realName;
            this.form.salesPhone = res.data.records[0].username;
            this.form.salesId = res.data.records[0].id;
          } else {
            this.form.salesPhone = "";
            this.form.salesId = "";
          }
          const serviceMan = this.findServiceMan(0, this.form.province, this.form.city, this.form.provincial, this.form.acceptAddress)
          if (serviceMan && serviceMan.mobile) {
            const user = await this.searchUserByMobile(serviceMan.mobile)
            if (user) {
              this.form.serviceMan = user.realName
              this.form.servicePhone = user.username
              this.form.serviceId = user.id
            }
          }
        }

        const { data: { dtuCode } } = await getDtuCode(this.batch)
        if (this.form.barcode && dtuCode && this.form.barcode !== dtuCode) {
          this.$confirm({
            title: this.$t("binding.differentDtucode"),
            content: (
              <div style="margin-bottom: -24px">
                <p>{ this.$t('common.dtuCode') + "1: " + this.form.barcode }</p>
                <p>{ this.$t('common.dtuCode') + "2: " + dtuCode }</p>
              </div>
            )
          })
        }
        this.setSIMInfo()
      } catch (e) {
        console.log(e);
      } finally {
        this.isSearching = false;
      }
    },
    async setSIMInfo() {
      if (this.form.barcode) {
        const { data } = await getSIMs(1, 10, {
          query: [],
          filter: [
            {
              field: "dtuCode",
              value: this.form.barcode
            }
          ],
          sort: []
        })
        if (data.total > 1) {
          return this.$message.warn(this.$t('SIM.multiple'))
        }
        if (data.total === 1) {
          const sim = data.records[0]
          this.giccid = sim.giccid
          this.simType = sim.status || "空"
        }
      }
    },
    async handleLGJSearch() {
      const form = {}
      try {
        let deviceInfo
        const JDYInfo = this.orders.find(o => o.batch === this.batch || o.batch === 'LJ' + this.batch)
        const terminalCustomerName = JDYInfo.terminalCustomerName?.trim()
  
        /* 设备信息 */
        form.type = 'LGJ'
        const { data } = await searchDeviceList(1, 10, {
          query: [
            {
              field: 'code',
              value: this.batch
            }
          ],
          filter: [
            {
              field: 'type',
              value: 'LGJ'
            }
          ],
          sort: []
        })
        if (data.records.length < 1) {
          return this.$message.warn(this.$t('binding.noDeviceInfo'))
        }
        if (data.records.length > 1) {
          return this.$message.info(this.$t('binding.exitDevice'))
        }
        deviceInfo = data.records[0]
        form.batch = deviceInfo.code
        form.name = deviceInfo.name
        form.deviceAddress = deviceInfo.deviceAddress.length < 2 ? "0" + deviceInfo.deviceAddress : deviceInfo.deviceAddress
        form.productModel = deviceInfo.model
        form.F_DEMAN_GFXH = JDYInfo.GFXH
        form.protocolCode = deviceInfo.protocolCode
        form.driverType = deviceInfo.driverType
        form.barcode = deviceInfo.dtuCode
        form.FNOTE = JDYInfo.note || deviceInfo.remark
        form.power = deviceInfo.power
        form.pressure = deviceInfo.pressure
        form.FDEMAN_ZJZB = deviceInfo.warrantyPeriod
        form.employeeName = undefined
        form.salesPhone = ''
        form.salesId = ''
        form.serviceMan = undefined
        form.servicePhone = ''
        form.serviceId = null
  
        /* 客户信息 */
        let customerId, c
        if (terminalCustomerName) {
          form.customerName = terminalCustomerName.trim()
          form.contractManager = JDYInfo?.terminalcontractManager || ''
          form.contractPhone = JDYInfo?.terminalcontractPhone || ''
        } else {
          form.customerName = JDYInfo?.customerName?.trim() || ''
          form.contractManager = JDYInfo?.contractManager || ''
          form.contractPhone = JDYInfo?.contractPhone || ''
        }
        customerId = await this.searchCustomer(form.customerName)
        if (customerId) {
          c = await getCustomerById(customerId)
          form.acceptAddress = c.data.address || JDYInfo?.address?.trim() || ''
          form.contractManager = c.data.contactPerson || form.contractManager;
          form.contractPhone = c.data.mobile || form.contractPhone;
          form.province = c.data.province || JDYInfo?.sheng?.trim() || ''
          form.city = c.data.city || JDYInfo?.shi?.trim() || ''
          form.provincial = c.data.area || JDYInfo?.qu?.trim() || ''
        } else {
          form.acceptAddress = JDYInfo?.address?.trim() || ''
          form.province =JDYInfo?.sheng?.trim() || '';
          form.city = JDYInfo?.shi?.trim() || '';
          form.provincial = JDYInfo?.qu?.trim() || '';
        }
  
        /* 售后信息 */
        if (customerId) {
          const { data } = await getCustomerById(customerId)
          if (data.salesmen?.length) {
            const salesman = data.salesmen[0]
            form.employeeName = salesman.realName
            form.salesPhone = salesman.username
            form.salesId = salesman.id
          }
          if (data.serviceMans?.length) {
            const serviceMan = data.serviceMans[0]
            form.serviceMan = serviceMan.realName
            form.servicePhone = serviceMan.username
            form.serviceId = serviceMan.id
          }
        } else {
          if (JDYInfo.departmentNumber.startsWith("06.02")) {
            let customerId = await this.searchCustomer(JDYInfo.customerName)
            if (customerId) {
              const { data } = await getCustomerById(customerId)
              if (data.users?.length) {
                const user = data.users[0]
                form.employeeName = user.realName
                form.salesPhone = user.username
                form.salesId = user.id
                console.log(user.id);
                form.serviceMan = user.realName
                form.servicePhone = user.username
                form.serviceId = user.id
              }
              if (data.salesmen?.length) {
                const salesman = data.salesmen[0]
                form.employeeName = salesman.realName
                form.salesPhone = salesman.username
                form.salesId = salesman.id
              }
              if (data.serviceMans?.length) {
                console.log(data.serviceMans);
                const serviceMan = data.serviceMans[0]
                form.serviceMan = serviceMan.realName
                form.servicePhone = serviceMan.username
                form.serviceId = serviceMan.id
              }
            }
          } else {
            // 销售员
            const { data } = await searchUserList(1, 10, {
              query: [
                {
                  field: 'realName',
                  value: JDYInfo.employeeName
                }
              ],
              filter: [],
              sort: []
            })
            if (data.total > 0) {
              const salesman = data.records[0]
              form.employeeName = salesman.realName
              form.salesPhone = salesman.username
              form.salesId = salesman.id
            } else {
              form.salesPhone = ''
              form.salesId = ''
            }
  
            // 服务员
            const serviceMan = this.findServiceMan(0, form.province, form.city, form.provincial, form.acceptAddress)
            if (serviceMan && serviceMan.mobile) {
              const user = await this.searchUserByMobile(serviceMan.mobile)
              if (user) {
                form.serviceMan = user.realName
                form.servicePhone = user.username
                form.serviceId = user.id
              }
            }
          }
        }
        if (JDYInfo.departmentNumber.startsWith("06.02")) {
          let customerId = await this.searchCustomer(JDYInfo.customerName)
          if (customerId) {
            const { data } = await getCustomerById(customerId)
            if (data.users?.length) {
              const user = data.users[0]
              form.employeeName = user.realName
              form.salesPhone = user.username
              form.salesId = user.id
              console.log(user.id);
              form.serviceMan = user.realName
              form.servicePhone = user.username
              form.serviceId = user.id
            }
            if (data.salesmen?.length) {
              const salesman = data.salesmen[0]
              form.employeeName = salesman.realName
              form.salesPhone = salesman.username
              form.salesId = salesman.id
            }
            if (data.serviceMans?.length) {
              console.log(data.serviceMans);
              const serviceMan = data.serviceMans[0]
              form.serviceMan = serviceMan.realName
              form.servicePhone = serviceMan.username
              form.serviceId = serviceMan.id
            }
          }
        } else if (data.departmentNumber.startsWith("06.03")) {
          let customerId
          if (data.terminalCustomerName?.trim()) {
            customerId = await this.searchCustomer(data.terminalCustomerName.trim())
          }
          if (customerId) {
            const c = await getCustomerById(customerId)
            const customer = c.data
            if (customer.users?.length) {
              this.form.employeeName = customer.users[0].realName;
              this.form.salesPhone = customer.users[0].username;
              this.form.salesId = customer.users[0].id;
              this.form.serviceMan = customer.users[0].realName;
              this.form.servicePhone = customer.users[0].username;
              this.form.serviceId = customer.users[0].id;
            }
            if (customer.salesmen?.length) {
              this.form.employeeName = customer.salesmen[0].realName;
              this.form.salesPhone = customer.salesmen[0].username;
              this.form.salesId = customer.salesmen[0].id;
            }
            if (customer.serviceMans?.length) {
              this.form.serviceMan = customer.serviceMans[0].realName;
              this.form.servicePhone = customer.serviceMans[0].username;
              this.form.serviceId = customer.serviceMans[0].id;
            }
          } else {
            customerId = await this.searchCustomer(data.customerName)
            if (customerId) {
              const c = await getCustomerById(customerId)
              const customer = c.data
              if (customer.users?.length) {
                this.form.employeeName = customer.users[0].realName;
                this.form.salesPhone = customer.users[0].username;
                this.form.salesId = customer.users[0].id;
                this.form.serviceMan = customer.users[0].realName;
                this.form.servicePhone = customer.users[0].username;
                this.form.serviceId = customer.users[0].id;
              }
              if (customer.salesmen?.length) {
                this.form.employeeName = customer.salesmen[0].realName;
                this.form.salesPhone = customer.salesmen[0].username;
                this.form.salesId = customer.salesmen[0].id;
              }
              if (customer.serviceMans?.length) {
                this.form.serviceMan = customer.serviceMans[0].realName;
                this.form.servicePhone = customer.serviceMans[0].username;
                this.form.serviceId = customer.serviceMans[0].id;
              }
            }
          }
        } else {
          // 销售员
          const { data } = await searchUserList(1, 10, {
            query: [
              {
                field: 'realName',
                value: JDYInfo.employeeName
              }
            ],
            filter: [],
            sort: []
          })
          if (data.total > 0) {
            const salesman = data.records[0]
            form.employeeName = salesman.realName
            form.salesPhone = salesman.username
            form.salesId = salesman.id
          } else {
            form.salesPhone = ''
            form.salesId = ''
          }

          // 服务员
          const serviceMan = this.findServiceMan(0, form.province, form.city, form.provincial, form.acceptAddress)
          if (serviceMan && serviceMan.mobile) {
            const user = await this.searchUserByMobile(serviceMan.mobile)
            if (user) {
              form.serviceMan = user.realName
              form.servicePhone = user.username
              form.serviceId = user.id
            }
          }
        }
        this.form = form
        this.setSIMInfo()
      } catch(e) {
        console.log(e)
      } finally {
        this.form = form
        this.isSearching = false
      }
    },
    findServiceMan(...args) {
      let index = args[0]
      const field = this.pointer[index]
      const value = args[1]
      let serviceMan, result = null
      
      breaker: for (let i = 0; i < this.serviceManList[field].length; i++) {
        serviceMan = this.serviceManList[field][i]
        for (let j = 0; j < serviceMan.match.length; j++) {
          if (value.includes(serviceMan.match[j])) {
            if (serviceMan.negation) {
              result = this.findServiceMan(index + 1, ...args.slice(2))
              if (!result) {
                result = serviceMan
              }
            } else {
              result = serviceMan
            }
            break breaker
          }
        }
      }
      
      return result
    },
    debounce(f, delay, ...args) {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        f(...args);
        this.timer = null;
      }, delay);
    },
    handleBlur() {
      this.page = 1;
      this.protocolList = [];
      this.userList = [];
      this.$forceUpdate();
    },
    handleProtocolChange(value) {
      const p = this.protocolList.find(p => p.code === value);
      this.form.driverType = p.driver;
    },
    async getProtocolList(e) {
      if (e.key === 'Enter') {
        e.target.value = e.target.value.trim()
        this.p = e.target.value
        if (this.p) {
          this.protocolPage = 1
          this.pSearchFlag = true
          const { data } = await searchProtocolCode(this.protocolPage, 10, e.target.value, e.target.value)
          this.LGJProtocolList = data.records
          if (data.total <= 10) {
            this.pSearchFlag = false
          }
        }
      }
    },
    selectProtocol(v) {
      const p = this.LGJProtocolList.find(l => l.code === v)
      this.form.driverType = p.driver
      this.form.protocolCode = v
    },
    async searchUserByMobile(mobile) {
      let result = null
      try {
        const { data } = await searchUserList(1, 10, {
          query: [],
          filter: [
            {
              field: 'username',
              value: mobile
            }
          ],
          sort: []
        })
        if (data.total) {
          result = data.records[0]
        }
      } catch(e) {
        console.log(e)
      } finally {
        return result
      }
    },
    async getUserList(e) {
      if (e.key === "Enter") {
        e.target.value = e.target.value.trim();
        this.o = e.target.value;
        if (this.o?.trim()) {
          this.usersPage = 1;
          this.sSearchFlag = true;
          const { data } = await searchUserList(this.usersPage, 10, {
            query: [
              {
                field: "realName",
                value: e.target.value
              }
            ],
            filter: [],
            sort: []
          });
          this.users = data.records;
          if (data.total === 0) {
            this.role = "销售员";
            this.realName = this.form.employeeName = e.target.value;
            this.visible = true;
          }
        }
      }
    },
    async getFollowerList(e) {
      if (e.key === "Enter") {
        e.target.value = e.target.value.trim();
        this.fs = e.target.value;
        if (this.fs?.trim()) {
          this.followerPage = 1;
          this.fSearchFlag = true;
          const { data } = await searchUserList(this.followerPage, 10, {
            query: [
              {
                field: "realName",
                value: e.target.value
              }
            ],
            filter: [],
            sort: []
          });
          this.followUserList = data.records;
          if (data.total === 0) {
            this.role = this.$t('common.followers')
            this.realName = e.target.value;
            this.visible = true;
          }
        }
      }
    },
    async getServiceList(e) {
      if (e.key === "Enter") {
        this.s = e.target.value;
        if (this.s?.trim()) {
          this.servicePage = 1;
          const { data } = await searchUserList(this.servicePage, 10, {
            query: [
              {
                field: "realName",
                value: e.target.value
              }
            ],
            filter: [],
            sort: []
          });
          this.serviceMan = data.records;
          if (data.total === 0) {
            this.role = this.$t('common.serviceMen');
            this.realName = this.form.serviceMan = e.target.value;
            this.visible = true;
          }
        }
      }
    },
    async getAllRole() {
      this.rolesPage = 1;
      let res = await getRoleList(1, 1000);
      if (res.data.total > 100) {
        res = await getRoleList(1, res.data.total);
      }
      this.roles = res.data.records;
    },
    async getRoleList(e) {
      if (e.key === "Enter") {
        this.r = e.target.value;
        if (this.r?.trim()) {
          this.rolePage = 1;
          const { data } = await searchRoleList(this.organizationsPage, 10, {
            query: [
              {
                field: "details.name",
                value: e.target.value
              }
            ],
            filter: [],
            sort: []
          });
          this.roles = data.records;
        } else {
          this.getAllRole();
        }
      }
    },
    async getAllOrga() {
      this.organizationsPage = 1;
      let res = await getOrganizationList(1, 1000);
      if (res.data.total > 1000) {
        res = await getOrganizationList(1, res.data.total);
      }
      this.organizations = res.data.records;
    },
    async getOrganizationList(e) {
      if (e.key === "Enter") {
        this.o = e.target.value;
        if (this.o?.trim()) {
          this.organizationsPage = 1;
          const { data } = await searchOrganizationList(
            this.organizationsPage,
            10,
            {
              query: [
                {
                  field: "details.name",
                  value: e.target.value
                }
              ],
              filter: [],
              sort: []
            }
          );
          this.organizations = data.records;
        } else {
          this.getAllOrga();
        }
      }
    },
    async handleProtocolPopupScroll(e) {
      if (!this.pSearchFlag) return;
      const { scrollHeight, scrollTop, clientHeight } = e.target
      if (scrollHeight - scrollTop === clientHeight) {
        this.protocolPage++
        const { data } = await searchProtocolCode(this.protocolPage, 10, this.p, this.p)
        this.LGJProtocolList = this.LGJProtocolList.concat(data.records)
        if (this.LGJProtocolList.length >= data.total) {
          this.pSearchFlag = false
        }
      }
    },
    async handlePopupScroll(e) {
      const { scrollHeight, scrollTop, clientHeight } = e.target;
      if (scrollHeight - scrollTop === clientHeight) {
        this.organizationsPage++;
        const { data } = await searchOrganizationList(
          this.organizationsPage,
          10,
          {
            query: [
              {
                field: "details.name",
                value: this.o
              }
            ],
            filter: [],
            sort: []
          }
        );
        this.organizations = this.organizations.concat(data.records);
      }
    },
    async handleRPopupScroll(e) {
      const { scrollHeight, scrollTop, clientHeight } = e.target;
      if (scrollHeight - scrollTop === clientHeight) {
        this.rolesPage++;
        const { data } = await searchRoleList(this.rolesPage, 10, {
          query: [
            {
              field: "details.name",
              value: this.r
            }
          ],
          filter: [],
          sort: []
        });
        this.roles = this.roles.concat(data.records);
      }
    },
    async handleFollwersPopupScroll(e) {
      const { scrollHeight, scrollTop, clientHeight } = e.target;
      if (scrollHeight - scrollTop === clientHeight) {
        this.followerPage++;
        const { data } = await searchUserList(this.followerPage, 10, {
          query: [
            {
              field: "details.name",
              value: this.fs
            }
          ],
          filter: [],
          sort: []
        });
        this.followUserList = this.followUserList.concat(data.records);
      }
    },
    selectUser(value) {
      const u = this.users.find(uu => uu.id === value);
      this.form.employeeName = u.realName;
      this.form.salesPhone = u.username;
      this.form.salesId = u.id;
      this.$forceUpdate()
    },
    selectService(value) {
      const u = this.serviceMan.find(uu => uu.id === value);
      this.form.serviceMan = u.realName;
      this.form.servicePhone = u.username;
      this.form.serviceId = u.id;
      this.$forceUpdate()
    },
    selectFollower(value) {
      const u = this.followUserList.find(uu => uu.id === value);
      this.followerName = u.realName;
      this.followerPhone = u.username;
      this.followeId = u.id;
    },
    async handleAfterClose(f) {
      this.mobile = ''
      this.record = {
        id: 0
      }
      this.usersVisible = false;
      const { data } = await searchUserList(1, 10, {
        query: [
          {
            field: "realName",
            value: f.realName
          },
          {
            field: "username",
            value: f.username
          }
        ]
      });
      const u = data.records[0];
      if (this.role === this.$t('common.salesMen')) {
        this.form.employeeName = u.realName;
        this.form.salesPhone = u.username;
        this.form.salesId = u.id;
      }
      if (this.role === this.$t('common.serviceMen')) {
        this.form.serviceMan = u.realName;
        this.form.servicePhone = u.username;
        this.form.serviceId = u.id;
      }
      if (this.role === this.$t('common.followers')) {
        this.followerName = u.realName;
        this.followerPhone = u.username;
        this.followeId = u.id;
      }
    },
    validatePhone(_, value, callback) {
      if (value.length > 5) {
        const phoneValidate = new RegExp(/[0-9]{11}$/).test(value);
        if (!phoneValidate) {
          callback(new Error(this.$t('messages.pemp')));
        }
      }
      callback();
    },
    async validate() {
      this.isRegisting = true;
      try {
        let flag = true;
        for (let i = 0; i < 3; i++) {
          this.$refs[`form${i}`].validate(valid => {
            flag = flag && valid;
          });
        }
        if (!flag) {
          this.isRegisting = false
          return;
        }
        this.confirmContent = []
        let cFlag = false
        if (this.form.F_DEMAN_GFXH.trim() && this.form.productModel !== this.form.F_DEMAN_GFXH) {
          this.confirmContent.push(this.$t('binding.diffModel'))
          cFlag = true
        }
        if (this.form.barcode?.length < 6) {
          this.confirmContent.push(this.$t('binding.dtuCodeLength'))
          cFlag = true
        }
        if (this.currentType[0] === 'KYJ') {
          const { data } = await searchDeviceList(1, 10, {
            query: [],
            filter: [
              {
                field: 'dtuCode',
                value: this.form.barcode
              }
            ]
          })
          if (data.total > 0) {
            this.confirmContent.push(this.$t('binding.exitDtuCode'))
            cFlag = true
          }
        }
        let customerId = await this.searchCustomer(this.form.customerName)
        let customerForm
        if (customerId) {
          const c = await getCustomerById(customerId);
          const customerInfo = c.data;
          customerForm = {
            id: customerInfo.id,
            company: customerInfo.company,
            address: customerInfo.address,
            mobile: customerInfo.mobile,
            contactPerson: customerInfo.contactPerson,
            province: customerInfo.province,
            city: customerInfo.city,
            area: customerInfo.area,
            lng: null,
            lat: null,
            users: customerInfo.users || [],
            salesmen: customerInfo.salesmen || [],
            serviceMans: customerInfo.serviceMans || [],
            followers: customerInfo.followers || []
          };
          if (!customerForm.salesmen.find(s => this.form.salesId && (s.id === +this.form.salesId))) {
            if (customerForm.salesmen.length > 0) {
              cFlag = true;
              console.log(customerForm.salesmen.map(s => s))
              this.confirmContent.push(this.$t('binding.asa') + this.form.employeeName + this.$t('binding.osa') + customerForm.salesmen.map(s => s.realName))
            }
          }
          if (
            !customerForm.serviceMans.find(s => this.form.serviceId && s.id === +this.form.serviceId)
          ) {
            if (customerForm.serviceMans.length > 0) {
              cFlag = true;
              this.confirmContent.push(this.$t('binding.ase') + this.form.serviceMan + this.$t('binding.ose') + customerForm.serviceMans.map(s => s.realName))
            }
          }
        }
        if (cFlag) {
          this.isConfirmShow = true
        } else {
          this.regist()
        }
      } catch (e) {
        console.log(e);
      }
    },
    async regist() {
      this.isConfirmShow = false
      try {
        /* 用户 */
        let userId;
        if (this.form.contractPhone.length > 5) {
          userId = await this.searchUser(
            this.form.contractManager,
            this.form.contractPhone
          );
          if (!userId) {
            const userForm = {
              username: this.form.contractPhone,
              realName: this.form.contractManager,
              admin: false,
              organizationId: 204,
              roleId: 4,
              enabled: true,
              requiredCaptcha: true
            };
            await addUser(userForm);
            this.$message.success(this.$t('binding.addUserScuccess'));
            userId = await this.searchUser(
              userForm.realName,
              userForm.username
            );
          }
        }

        /* 客户 */
        let customerId = await this.searchCustomer(this.form.customerName);
        let customerForm;
        if (customerId) {
          const c = await getCustomerById(customerId);
          const customerInfo = c.data;
          customerForm = {
            id: customerInfo.id,
            company: customerInfo.company,
            address: customerInfo.address,
            mobile: customerInfo.mobile,
            contactPerson: customerInfo.contactPerson,
            province: customerInfo.province,
            city: customerInfo.city,
            area: customerInfo.area,
            lng: null,
            lat: null,
            users: (customerInfo.users || []).map(u => {
              return {
                id: u.id,
                maintainSmsEnabled: u.maintainSmsEnabled || false,
                insepectionSmsEnabled: u.insepectionSmsEnabled || false,
                errorSmsEnabled: u.errorSmsEnabled || false
              };
            }),
            salesmen: (customerInfo.salesmen || []).map(u => {
              return {
                id: u.id,
                maintainSmsEnabled: u.maintainSmsEnabled || false,
                insepectionSmsEnabled: u.insepectionSmsEnabled || false,
                errorSmsEnabled: u.errorSmsEnabled || false
              };
            }),
            serviceMans: (customerInfo.serviceMans || []).map(u => {
              return {
                id: u.id,
                maintainSmsEnabled: u.maintainSmsEnabled || false,
                insepectionSmsEnabled: u.insepectionSmsEnabled || false,
                errorSmsEnabled: u.errorSmsEnabled || false
              };
            }),
            followers: (customerInfo.followers || []).map(u => {
              return {
                id: u.id,
                maintainSmsEnabled: u.maintainSmsEnabled || false,
                insepectionSmsEnabled: u.insepectionSmsEnabled || false,
                errorSmsEnabled: u.errorSmsEnabled || false
              };
            })
          };
          let flag = false;
          if (customerForm.address !== this.form.acceptAddress) {
            customerForm.address = this.form.acceptAddress;
            flag = true;
          }
          if (customerForm.mobile !== this.form.contractPhone) {
            customerForm.mobile = this.form.contractPhone;
            flag = true;
          }
          if (customerForm.province !== this.form.province) {
            customerForm.province = this.form.province;
            flag = true;
          }
          if (customerForm.city !== this.form.city) {
            customerForm.city = this.form.city;
            flag = true;
          }
          if (customerForm.area !== this.form.provincial) {
            customerForm.area = this.form.provincial;
            flag = true;
          }
          if (userId) {
            if (!customerForm.users.find(u => u.id === +userId)) {
              flag = true;
              customerForm.users.push({
                id: +userId,
                maintainSmsEnabled:
                  this.userMaintainSmsEnabled === undefined
                    ? true
                    : this.userMaintainSmsEnabled,
                insepectionSmsEnabled: false,
                errorSmsEnabled: false
              });
            }
          }
          if (!customerForm.salesmen.find(s => this.form.salesId && (s.id === +this.form.salesId))) {
            flag = true;
            customerForm.salesmen.push({
              id: +this.form.salesId,
              maintainSmsEnabled: false,
              insepectionSmsEnabled: false,
              errorSmsEnabled: false
            });
          }
          if (
            !customerForm.serviceMans.find(s => this.form.serviceId && (s.id === +this.form.serviceId))
          ) {
            flag = true;
            customerForm.serviceMans.push({
              id: +this.form.serviceId,
              maintainSmsEnabled: true,
              insepectionSmsEnabled: true,
              errorSmsEnabled: true
            });
          }
          if (flag) {
            await updateCustomer(customerForm);
            this.$message.success(this.$t('binding.updateCustomerSuccess'));
          }
        } else {
          customerForm = {
            company: this.form.customerName,
            address: this.form.acceptAddress,
            mobile: this.form.contractPhone,
            contactPerson: this.form.contractManager,
            province: this.form.province,
            city: this.form.city,
            area: this.form.provincial,
            lng: null,
            lat: null,
            users: [],
            salesmen: [
              {
                id: +this.form.salesId,
                maintainSmsEnabled: false,
                insepectionSmsEnabled: false,
                errorSmsEnabled: false
              }
            ],
            serviceMans: [
              {
                id: +this.form.serviceId,
                maintainSmsEnabled: true,
                insepectionSmsEnabled: true,
                errorSmsEnabled: true
              }
            ],
            followers: []
          };
          if (userId) {
            customerForm.users.push({
              id: +userId,
              maintainSmsEnabled:
                this.userMaintainSmsEnabled === undefined
                  ? true
                  : this.userMaintainSmsEnabled,
              insepectionSmsEnabled: false,
              errorSmsEnabled: false
            });
          }
          await addCustomer(customerForm);
          this.$message.success(this.$t('binding.addCustomerSuccess'));
          customerId = await this.searchCustomer(customerForm.company);
        }

        /* 设备 */
        const device = await searchDeviceList(1, 10, {
          query: [],
          filter: [
            {
              field: "code",
              value: this.form.batch
            }
          ],
          sort: []
        });
        if (device.data.total > 0) {
          const d = device.data.records[0];
          const deviceForm = {
            id: d.id,
            code: this.form.batch,
            name: this.form.name,
            type: this.form.type,
            status: d.status,
            deviceAddress: d.deviceAddress.length < 2 ? "0" + d.deviceAddress : d.deviceAddress,
            model: this.form.productModel,
            brand: d.brand,
            customerId,
            installAddress: d.installAddress,
            driverType: this.form.driverType,
            protocolCode: this.form.protocolCode,
            measurement: d.measurement,
            dtuCode: this.form.barcode,
            remark: d.remark,
            isStationDevice: d.isStationDevice,
            initialValue: d.initialValue,
            power: this.form.power,
            pressure: this.form.pressure,
            warrantyPeriod: null,
            intervalTime: d.intervalTime || 180,
            enabled: d.enabled,
            tag: d.tag ? d.tag : null
          };
          deviceForm.bindingDevices = d.bindingDevices || []
          await updateDevice(deviceForm);
          this.$message.success(this.$t('binding.updateDevice'));
        } else {
          const deviceForm = {
            code: this.form.batch,
            name: this.form.name,
            type: this.form.type,
            status: null,
            deviceAddress: this.form.deviceAddress.length < 2 ? "0" + this.form.deviceAddress : this.form.deviceAddress,
            model: this.form.productModel,
            brand: "",
            customerId,
            installAddress: '',
            driverType: this.form.driverType,
            protocolCode: this.form.protocolCode,
            measurement: "",
            dtuCode: this.form.barcode,
            remark: "",
            isStationDevice: true,
            initialValue: "",
            power: this.form.power,
            pressure: this.form.pressure,
            warrantyPeriod: null,
            bindingDevices: [],
            intervalTime: this.form.type === 'KYJ' ? 180 : null,
            tag: null
          };
          await addDevice(deviceForm);
          this.$message.success(this.$t('binding.addDevice'));
        }
        if (this.currentType[0] === 'KYJ') {
          this.getDeviceList();
        }
        if (this.currentType[0] === 'LGJ') {
          const { data } = await getLGJList(this.date.format('YYYY-MM-DD'))
          this.orders = data
        }
      } catch (e) {
        console.log(e);
      } finally {
        this.isRegisting = false;
      }
    },
    async searchUser(realName, username) {
      const { data } = await searchUserList(1, 10, {
        filter: [
          {
            field: "username",
            value: username
          }
        ],
        sort: []
      });

      if (data.total > 0) {
        this.form.contractManager = data.records[0].realName;
        this.form.contractPhone = data.records[0].username;
        if (data.records[0].organizationId === 14) {
          this.userMaintainSmsEnabled = false;
        } else {
          this.userMaintainSmsEnabled = true;
        }
        return data.records[0].id;
      } else {
        return null;
      }
    },
    async searchCustomer(value) {
      const { data } = await searchCustomerList(1, 10, {
        query: [],
        filter: [
          {
            field: "company",
            value
          }
        ],
        sort: []
      });
      if (data.total > 0) {
        return data.records[0].id;
      } else {
        return null;
      }
    },
    toggleColumns(t, f) {
      this.orders = []
      this.columns = this.columnsMap[t]
      this.batch = ""
      if (t === "KYJ") {
        this.form = {
          type: "KYJ",
          name: "空压机",
          deviceAddress: "02",
          protocolCode: "",
          driverType: "MODBUS_RTU",
          batch: "",
          productModel: "",
          F_DEMAN_GFXH: "",
          barcode: "",
          FNOTE: "",
          power: "",
          pressure: "",
          FDEMAN_ZJZB: "",
          customerName: "",
          acceptAddress: "",
          contractManager: "",
          contractPhone: "",
          province: "",
          city: "",
          provincial: "",
          employeeName: "",
          salesPhone: "",
          salesId: "",
          serviceMan: "",
          servicePhone: "",
          serviceId: ""
        }
      }
      if (t === "LGJ") {
        this.form = {
          type: "LGJ",
          name: "",
          deviceAddress: "",
          protocolCode: "",
          driverType: "MODBUS_RTU",
          batch: "",
          productModel: "",
          F_DEMAN_GFXH: "",
          barcode: "",
          FNOTE: "",
          power: "",
          pressure: "",
          FDEMAN_ZJZB: "",
          customerName: "",
          acceptAddress: "",
          contractManager: "",
          contractPhone: "",
          province: "",
          city: "",
          provincial: "",
          employeeName: "",
          salesPhone: "",
          salesId: "",
          serviceMan: "",
          servicePhone: "",
          serviceId: ""
        }
      }
      if (t === "URC") {
        this.form = {
          type: "",
          name: "",
          deviceAddress: "",
          protocolCode: "",
          driverType: "",
          batch: "",
          productModel: "",
          F_DEMAN_GFXH: "",
          barcode: "",
          FNOTE: "",
          power: "",
          pressure: "",
          FDEMAN_ZJZB: "",
          customerName: "",
          acceptAddress: "",
          contractManager: "",
          contractPhone: "",
          province: "",
          city: "",
          provincial: "",
          employeeName: "",
          salesPhone: "",
          salesId: "",
          serviceMan: "",
          servicePhone: "",
          serviceId: ""
        }
      }
      this[f]()
    },
    handleSearch() {
      if (this.currentType[0] === 'KYJ') {
        this.getDeviceList()
      }
      if (this.currentType[0] === 'LGJ') {
        this.getLGJList()
      }
      if (this.currentType[0] === 'URC') {
        this.getUnRegistCustomers()
      }
    },
    async getDtuCode() {
      if (!this.batch.trim()) {
        return this.$message.warn(this.$t('binding.edc'))
      }
      this.isDLoading = true
      try {
        const { data } = await getDtuCode(this.batch)
        this.form.barcode = data.dtuCode
        this.setSIMInfo()
      } catch(e) {
        this.form.barcode = ''
        console.log(e)
      } finally {
        this.isDLoading = false
      }
    },
    async resend() {
      if (!this.batch.trim()) {
        return this.$message.warn(this.$t('binding.edc'))
      }
      const { data } = await searchDeviceList(1, 10, {
        query: [
          {
            field: 'code',
            value: this.batch
          }
        ],
        filter: [],
        sort: []
      })
      if (data.total) {
        const d = data.records[0]
        const deviceForm = {
          id: d.id,
          code: d.code,
          name: d.name,
          type: d.type,
          status: d.status,
          deviceAddress: d.deviceAddress.length < 2 ? "0" + d.deviceAddress : d.deviceAddress,
          model: d.model,
          brand: d.brand,
          customerId: d.customerId,
          installAddress: d.installAddress,
          driverType: d.driverType,
          protocolCode: d.protocolCode,
          measurement: d.measurement,
          dtuCode: d.dtuCode,
          remark: d.remark,
          isStationDevice: d.isStationDevice,
          initialValue: d.initialValue,
          power: d.power,
          pressure: d.pressure,
          warrantyPeriod: null,
          intervalTime: d.intervalTime || 180,
          enabled: d.enabled,
          createdAt: +new Date(),
          updatedAt: +new Date(),
          tag: d.tag || null
        };
        deviceForm.bindingDevices = d.bindingDevices || []
        await updateDevice(deviceForm)
        this.$message.success(this.$t('binding.updateDevice'))
      }
    },
    async getUnRegistCustomers() {
      if (!this.date) {
        return this.$message.error(this.$t('device.selectDate'));
      }
      this.isLoading = true
      try {
        const { data } = await postUnRegCustomer(this.date.format("YYYY-MM-DD"))
        this.orders = data.map(d => {
          d.batch = d.customerId
          return d
        })
      } catch(e) {
        console.log(e)
      } finally {
        this.isLoading = false
      }
    },
    async activateSIM() {
      this.isActivating = true
      if (!this.giccid) {
        this.isActivating = false
        return this.$message.warn(this.$t('SIM.empty'))
      }
      try {
        const { message } = await activateSIM(this.giccid)
        this.$message.success(message)
      } catch(e) {
        console.log(e)
      } finally {
        this.isActivating = false
      }
    }
  }
};
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  padding: 10px;
  > div:not(:last-child) {
    width: 50%;
    height: 100%;
  }
  h2 {
    font-size: 18px;
  }
}
.order {
  padding: 0 20px;
}
.search,
section {
  width: 100%;
}
.ant-form-inline .ant-form-item {
  width: 255px;
  margin-bottom: 15px;
}
.order .ant-form-inline .ant-form-item {
  width: unset;
}
// .service .ant-form-inline .ant-form-item {
//   width: unset;
// }
.form {
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  /deep/ textarea.ant-input {
    max-width: unset;
  }
}
</style>